export const S3_STORAGE_TOKENS_ARTWORK_DIR = '/tokens/artworks';
